import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import { CarOrderingContext } from "../../CarOrdering";
import Tip from "../Misc/Tip";
import StepOption from "./StepOption";

export default function StepSetting({
  setting,
  className = '',
  hidePrice = false
}) {
  const {
    order,
    setOrder,
    setInteriorImage
  } = useContext(CarOrderingContext)

  const [checkedOptions, setCheckedOptions] = useState(order?.configuration?.settings?.[setting.id] ?? [])

  const setChecked = (value) => {
    const option = setting.options.find(option => option.id === value)
    const isChecked = checkedOptions.some(checkedOption => checkedOption.id === option.id)

    let newCheckedOptions = [...checkedOptions]

    if (setting.required) {
      newCheckedOptions = [option]
      setInteriorImage(option)
    } else {
      if (isChecked) {
        newCheckedOptions = newCheckedOptions.filter(checkedOption => checkedOption.id !== option.id)
        setInteriorImage(null)
      } else {
        newCheckedOptions.push(option)
        setInteriorImage(option)
      }
    }

    setCheckedOptions(newCheckedOptions)
  }

  const isChecked = (option) => checkedOptions.some(checkedOption => checkedOption.id === option.id)

  useEffect(() => {
    setOrder({
      ...order,
      configuration: {
        ...order.configuration,
        settings: {
          ...order.configuration?.settings ?? {},
          [setting.id]: checkedOptions
        }
      }
    })
  }, [checkedOptions])

  const optionElements = setting.options.map((option, index) => (
    <StepOption
      key={index}
      option={option}
      layout={setting.layout}
      settingId={setting.id}
      checked={isChecked(option)}
      setChecked={setChecked}
      required={setting.required}
      hidePrice={hidePrice}
    />
  ))

  return (
    <>
      <div className={classNames('setting', className)} data-setting-id={setting.id}>
        <h3 className='config-subtitle'>
          {setting.label}
          {typeof setting.description === 'string' && setting.description.length > 0 && (
            <Tip button='Ok' content={setting.description}/>
          )}
        </h3>
        <div className='config-radio' data-option-count={optionElements.length}>
          {optionElements}
        </div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}
